/**
 * How many rows a list shows, for the whole admin console.
 *
 * ONE default, plus a named exception list. Five tables page — staff,
 * cases, questions, exams, results — and a per-table constant is how
 * three of them end up at 50 and two at 20 with nobody able to say why.
 *
 * To change everything: edit `DEFAULT_PAGE_SIZE`.
 * To change ONE area: add it to `PAGE_SIZE_OVERRIDES`, e.g.
 *
 *     const PAGE_SIZE_OVERRIDES: Partial<Record<PagedArea, number>> = {
 *       exams: 10,
 *     };
 *
 * Anything not named there follows the default, so the exception is
 * visible as an exception rather than hidden in the component that
 * happens to use it.
 */

/** Every list that pages. Adding one here makes the compiler ask for it. */
export type PagedArea =
  | "staff"
  | "cases"
  | "questions"
  | "exams"
  | "results";

/** What every area uses unless it is named below. */
export const DEFAULT_PAGE_SIZE = 20;

/** Areas that deliberately differ. Empty means "everything is the same". */
const PAGE_SIZE_OVERRIDES: Partial<Record<PagedArea, number>> = {};

export function pageSizeFor(area: PagedArea): number {
  return PAGE_SIZE_OVERRIDES[area] ?? DEFAULT_PAGE_SIZE;
}

/** Offered in the rows-per-page control on every pager. */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;

/**
 * What a PICKER asks for.
 *
 * A checklist wants every row, not a page — a different question from
 * "how much does a table show", so it does not share the number. The
 * server's own cap is what bounds it.
 */
export const PICKER_PAGE_SIZE = 500;
